import { gameData } from "../../GameManager";
import { Actor } from "../Actor";

export const endOfTurnEffects = () => {
  gameData.actors.forEach((a) => {
    expireStatuses(a);
    clearStates(a);
  });
};

export const expireStatuses = (a: Actor) => {
  //TODO: Statuses?
};

export const clearStates = (a: Actor) => {
  a.status.waited = false;
  a.status.hit = false;
  a.status.moved = false;
};
